export const EMOJI_CATEGORIES = [
    { key: 'smileys', label: 'Smileys' },
    { key: 'people', label: 'People' },
    { key: 'nature', label: 'Nature' },
    { key: 'food', label: 'Food' },
    { key: 'activity', label: 'Activity' },
    { key: 'travel', label: 'Travel' },
    { key: 'objects', label: 'Objects' },
    { key: 'symbols', label: 'Symbols' },
    { key: 'flags', label: 'Flags' },
];
const ROWS = {
    smileys: [
        ['😀', 'grinning face', 'smile happy'],
        ['😃', 'grinning face with big eyes', 'smile happy'],
        ['😄', 'grinning face with smiling eyes', 'smile happy laugh'],
        ['😁', 'beaming face with smiling eyes', 'grin'],
        ['😆', 'grinning squinting face', 'laugh'],
        ['😅', 'grinning face with sweat', 'phew relief nervous'],
        ['🤣', 'rolling on the floor laughing', 'rofl lol'],
        ['😂', 'face with tears of joy', 'lol laugh crying'],
        ['🙂', 'slightly smiling face', 'smile'],
        ['🙃', 'upside down face', 'silly sarcasm'],
        ['😉', 'winking face', 'wink'],
        ['😊', 'smiling face with smiling eyes', 'blush happy'],
        ['😇', 'smiling face with halo', 'angel innocent'],
        ['🥰', 'smiling face with hearts', 'love adore'],
        ['😍', 'smiling face with heart eyes', 'love crush'],
        ['🤩', 'star struck', 'wow amazing'],
        ['😘', 'face blowing a kiss', 'kiss love'],
        ['😋', 'face savoring food', 'yum delicious'],
        ['😛', 'face with tongue', 'cheeky'],
        ['😜', 'winking face with tongue', 'joke silly'],
        ['🤪', 'zany face', 'crazy goofy'],
        ['🤑', 'money mouth face', 'rich cash'],
        ['🤗', 'smiling face with open hands', 'hug thanks'],
        ['🤭', 'face with hand over mouth', 'oops giggle'],
        ['🫢', 'face with open eyes and hand over mouth', 'shock gasp'],
        ['🤫', 'shushing face', 'quiet secret'],
        ['🤔', 'thinking face', 'hmm think consider'],
        ['🫡', 'saluting face', 'yes sir respect ok'],
        ['🤐', 'zipper mouth face', 'secret quiet'],
        ['🤨', 'face with raised eyebrow', 'suspicious skeptical'],
        ['😐', 'neutral face', 'meh'],
        ['😑', 'expressionless face', 'blank'],
        ['😶', 'face without mouth', 'speechless'],
        ['🫥', 'dotted line face', 'invisible hide'],
        ['😏', 'smirking face', 'smirk'],
        ['😒', 'unamused face', 'meh annoyed'],
        ['🙄', 'face with rolling eyes', 'eyeroll whatever'],
        ['😬', 'grimacing face', 'awkward yikes'],
        ['😮‍💨', 'face exhaling', 'sigh relief'],
        ['🤥', 'lying face', 'liar'],
        ['😌', 'relieved face', 'calm relief'],
        ['😔', 'pensive face', 'sad'],
        ['😪', 'sleepy face', 'tired'],
        ['🤤', 'drooling face', 'want'],
        ['😴', 'sleeping face', 'tired zzz'],
        ['😷', 'face with medical mask', 'sick ill'],
        ['🤒', 'face with thermometer', 'sick ill fever'],
        ['🤕', 'face with head bandage', 'hurt injured'],
        ['🤢', 'nauseated face', 'sick gross'],
        ['🤧', 'sneezing face', 'sick cold'],
        ['🥵', 'hot face', 'heat sweating'],
        ['🥶', 'cold face', 'freezing'],
        ['🥴', 'woozy face', 'dizzy'],
        ['😵', 'face with crossed out eyes', 'dizzy dead'],
        ['🤯', 'exploding head', 'mind blown shocked'],
        ['🤠', 'cowboy hat face', 'yeehaw'],
        ['🥳', 'partying face', 'party celebrate birthday'],
        ['🥸', 'disguised face', 'incognito'],
        ['😎', 'smiling face with sunglasses', 'cool'],
        ['🤓', 'nerd face', 'geek'],
        ['🧐', 'face with monocle', 'inspect curious'],
        ['😕', 'confused face', 'unsure'],
        ['🫤', 'face with diagonal mouth', 'unsure meh'],
        ['😟', 'worried face', 'concern'],
        ['🙁', 'slightly frowning face', 'sad'],
        ['😮', 'face with open mouth', 'wow surprised'],
        ['😯', 'hushed face', 'surprised'],
        ['😲', 'astonished face', 'shocked'],
        ['😳', 'flushed face', 'embarrassed'],
        ['🥺', 'pleading face', 'please puppy eyes'],
        ['🥹', 'face holding back tears', 'grateful touched'],
        ['😦', 'frowning face with open mouth', 'shock'],
        ['😧', 'anguished face', 'pain'],
        ['😨', 'fearful face', 'scared'],
        ['😰', 'anxious face with sweat', 'nervous'],
        ['😥', 'sad but relieved face', 'phew'],
        ['😢', 'crying face', 'sad tear'],
        ['😭', 'loudly crying face', 'sob sad'],
        ['😱', 'face screaming in fear', 'scream shock'],
        ['😖', 'confounded face', 'frustrated'],
        ['😣', 'persevering face', 'struggle'],
        ['😞', 'disappointed face', 'sad'],
        ['😓', 'downcast face with sweat', 'hard work'],
        ['😩', 'weary face', 'tired frustrated'],
        ['😫', 'tired face', 'exhausted'],
        ['🥱', 'yawning face', 'bored tired'],
        ['😤', 'face with steam from nose', 'triumph frustrated'],
        ['😡', 'enraged face', 'angry mad'],
        ['😠', 'angry face', 'mad'],
        ['🤬', 'face with symbols on mouth', 'swearing'],
        ['😈', 'smiling face with horns', 'devil mischief'],
        ['💀', 'skull', 'dead lol'],
        ['💩', 'pile of poo', 'poop'],
        ['🤡', 'clown face', 'clown'],
        ['👻', 'ghost', 'boo halloween'],
        ['👽', 'alien', 'ufo'],
        ['🤖', 'robot', 'bot ai'],
        ['😺', 'grinning cat', 'cat'],
        ['🙈', 'see no evil monkey', 'monkey shy oops'],
        ['🙉', 'hear no evil monkey', 'monkey'],
        ['🙊', 'speak no evil monkey', 'monkey oops'],
        ['❤️', 'red heart', 'love like'],
        ['🧡', 'orange heart', 'love'],
        ['💛', 'yellow heart', 'love'],
        ['💚', 'green heart', 'love'],
        ['💙', 'blue heart', 'love'],
        ['💜', 'purple heart', 'love'],
        ['🖤', 'black heart', 'love'],
        ['🤍', 'white heart', 'love'],
        ['💔', 'broken heart', 'sad'],
        ['❤️‍🔥', 'heart on fire', 'passion'],
        ['💕', 'two hearts', 'love'],
        ['💖', 'sparkling heart', 'love'],
        ['💯', 'hundred points', '100 perfect'],
        ['💢', 'anger symbol', 'angry'],
        ['💥', 'collision', 'boom'],
        ['💫', 'dizzy', 'star'],
        ['💦', 'sweat droplets', 'water'],
        ['💬', 'speech balloon', 'comment chat'],
        ['💭', 'thought balloon', 'think'],
        ['💤', 'zzz', 'sleep'],
    ],
    people: [
        ['👋', 'waving hand', 'hi hello bye wave', 1],
        ['🤚', 'raised back of hand', 'stop', 1],
        ['🖐️', 'hand with fingers splayed', 'hand', 1],
        ['✋', 'raised hand', 'stop high five', 1],
        ['🖖', 'vulcan salute', 'spock', 1],
        ['👌', 'ok hand', 'ok perfect', 1],
        ['🤌', 'pinched fingers', 'italian', 1],
        ['🤏', 'pinching hand', 'small tiny', 1],
        ['✌️', 'victory hand', 'peace', 1],
        ['🤞', 'crossed fingers', 'luck hope', 1],
        ['🫰', 'hand with index finger and thumb crossed', 'money love', 1],
        ['🤟', 'love you gesture', 'love', 1],
        ['🤘', 'sign of the horns', 'rock', 1],
        ['🤙', 'call me hand', 'call shaka', 1],
        ['👈', 'backhand index pointing left', 'left point', 1],
        ['👉', 'backhand index pointing right', 'right point', 1],
        ['👆', 'backhand index pointing up', 'up point', 1],
        ['👇', 'backhand index pointing down', 'down point', 1],
        ['☝️', 'index pointing up', 'one point', 1],
        ['🫵', 'index pointing at the viewer', 'you', 1],
        ['👍', 'thumbs up', 'yes like agree approve +1', 1],
        ['👎', 'thumbs down', 'no dislike -1', 1],
        ['✊', 'raised fist', 'power', 1],
        ['👊', 'oncoming fist', 'fist bump', 1],
        ['🤛', 'left facing fist', 'fist bump', 1],
        ['🤜', 'right facing fist', 'fist bump', 1],
        ['👏', 'clapping hands', 'clap applause well done', 1],
        ['🙌', 'raising hands', 'hooray celebrate yay', 1],
        ['🫶', 'heart hands', 'love thanks', 1],
        ['👐', 'open hands', 'hug', 1],
        ['🤲', 'palms up together', 'please', 1],
        ['🤝', 'handshake', 'deal agree', 1],
        ['🙏', 'folded hands', 'please thanks pray', 1],
        ['✍️', 'writing hand', 'write', 1],
        ['💅', 'nail polish', 'nails sassy', 1],
        ['🤳', 'selfie', 'photo', 1],
        ['💪', 'flexed biceps', 'strong muscle', 1],
        ['🧠', 'brain', 'smart think'],
        ['👀', 'eyes', 'look watching seen'],
        ['👁️', 'eye', 'look'],
        ['👂', 'ear', 'listen hear', 1],
        ['👃', 'nose', 'smell', 1],
        ['👄', 'mouth', 'lips'],
        ['👶', 'baby', 'child', 1],
        ['🧒', 'child', 'kid', 1],
        ['👦', 'boy', 'kid', 1],
        ['👧', 'girl', 'kid', 1],
        ['🧑', 'person', 'adult', 1],
        ['👨', 'man', 'adult', 1],
        ['👩', 'woman', 'adult', 1],
        ['🧓', 'older person', 'old', 1],
        ['👴', 'old man', 'old', 1],
        ['👵', 'old woman', 'old', 1],
        ['🙋', 'person raising hand', 'question me', 1],
        ['🙆', 'person gesturing ok', 'ok yes', 1],
        ['🙅', 'person gesturing no', 'no', 1],
        ['🤷', 'person shrugging', 'shrug dunno', 1],
        ['🤦', 'person facepalming', 'facepalm', 1],
        ['💁', 'person tipping hand', 'info sassy', 1],
        ['🙇', 'person bowing', 'sorry thanks', 1],
        ['🧑‍💻', 'technologist', 'developer coder laptop', 1],
        ['🧑‍🎨', 'artist', 'designer', 1],
        ['🧑‍💼', 'office worker', 'business', 1],
        ['🧑‍🔧', 'mechanic', 'fix', 1],
        ['🧑‍🏫', 'teacher', 'teach', 1],
        ['🧑‍🚀', 'astronaut', 'space', 1],
        ['🕵️', 'detective', 'investigate sleuth', 1],
        ['🥷', 'ninja', 'stealth', 1],
        ['🦸', 'superhero', 'hero', 1],
        ['🧙', 'mage', 'wizard magic', 1],
        ['🏃', 'person running', 'run hurry', 1],
        ['🚶', 'person walking', 'walk', 1],
        ['💃', 'woman dancing', 'dance party', 1],
        ['🕺', 'man dancing', 'dance party', 1],
        ['🧘', 'person in lotus position', 'calm yoga', 1],
        ['🛌', 'person in bed', 'sleep', 1],
        ['👥', 'busts in silhouette', 'people team'],
        ['🫂', 'people hugging', 'hug support'],
    ],
    nature: [
        ['🐶', 'dog face', 'dog puppy'],
        ['🐱', 'cat face', 'cat kitten'],
        ['🐭', 'mouse face', 'mouse'],
        ['🐰', 'rabbit face', 'bunny'],
        ['🦊', 'fox', 'fox'],
        ['🐻', 'bear', 'bear'],
        ['🐼', 'panda', 'panda'],
        ['🐨', 'koala', 'australia'],
        ['🐯', 'tiger face', 'tiger'],
        ['🦁', 'lion', 'lion'],
        ['🐮', 'cow face', 'cow'],
        ['🐷', 'pig face', 'pig'],
        ['🐸', 'frog', 'frog'],
        ['🐵', 'monkey face', 'monkey'],
        ['🐔', 'chicken', 'chicken'],
        ['🐧', 'penguin', 'penguin'],
        ['🐦', 'bird', 'bird'],
        ['🦆', 'duck', 'duck'],
        ['🦉', 'owl', 'wise'],
        ['🦘', 'kangaroo', 'australia'],
        ['🐝', 'honeybee', 'bee busy'],
        ['🐛', 'bug', 'bug insect'],
        ['🦋', 'butterfly', 'butterfly'],
        ['🐌', 'snail', 'slow'],
        ['🐢', 'turtle', 'slow'],
        ['🐍', 'snake', 'python'],
        ['🦖', 'T-Rex', 'dinosaur'],
        ['🐙', 'octopus', 'octopus'],
        ['🦀', 'crab', 'crab'],
        ['🐬', 'dolphin', 'dolphin'],
        ['🐳', 'spouting whale', 'whale docker'],
        ['🦈', 'shark', 'shark'],
        ['🐘', 'elephant', 'elephant'],
        ['🦄', 'unicorn', 'magic rare'],
        ['🐾', 'paw prints', 'paws'],
        ['🌵', 'cactus', 'desert'],
        ['🌲', 'evergreen tree', 'tree'],
        ['🌳', 'deciduous tree', 'tree'],
        ['🌴', 'palm tree', 'beach holiday'],
        ['🌱', 'seedling', 'grow new'],
        ['🌿', 'herb', 'plant'],
        ['🍀', 'four leaf clover', 'luck'],
        ['🍁', 'maple leaf', 'autumn'],
        ['🍂', 'fallen leaf', 'autumn'],
        ['🌷', 'tulip', 'flower'],
        ['🌹', 'rose', 'flower'],
        ['🌻', 'sunflower', 'flower'],
        ['🌸', 'cherry blossom', 'flower spring'],
        ['💐', 'bouquet', 'flowers thanks'],
        ['🍄', 'mushroom', 'fungus'],
        ['🌍', 'globe showing Europe-Africa', 'world earth'],
        ['🌏', 'globe showing Asia-Australia', 'world earth australia'],
        ['🌙', 'crescent moon', 'night'],
        ['⭐', 'star', 'favourite'],
        ['🌟', 'glowing star', 'shine'],
        ['✨', 'sparkles', 'new shiny magic'],
        ['☀️', 'sun', 'sunny weather'],
        ['⛅', 'sun behind cloud', 'weather'],
        ['🌧️', 'cloud with rain', 'rain weather'],
        ['⛈️', 'cloud with lightning and rain', 'storm'],
        ['❄️', 'snowflake', 'cold winter'],
        ['🔥', 'fire', 'hot lit flame'],
        ['🌈', 'rainbow', 'pride'],
        ['⚡', 'high voltage', 'lightning fast'],
        ['🌊', 'water wave', 'ocean surf'],
        ['💧', 'droplet', 'water'],
    ],
    food: [
        ['🍽️', 'fork and knife with plate', 'lunch dinner meal'],
        ['🍎', 'red apple', 'fruit'],
        ['🍊', 'tangerine', 'orange fruit'],
        ['🍋', 'lemon', 'fruit'],
        ['🍌', 'banana', 'fruit'],
        ['🍉', 'watermelon', 'fruit summer'],
        ['🍇', 'grapes', 'fruit'],
        ['🍓', 'strawberry', 'fruit'],
        ['🍑', 'peach', 'fruit'],
        ['🍍', 'pineapple', 'fruit'],
        ['🥭', 'mango', 'fruit'],
        ['🥑', 'avocado', 'smashed avo'],
        ['🥕', 'carrot', 'vegetable'],
        ['🌽', 'ear of corn', 'vegetable'],
        ['🌶️', 'hot pepper', 'spicy chilli'],
        ['🥦', 'broccoli', 'vegetable'],
        ['🍞', 'bread', 'toast'],
        ['🥐', 'croissant', 'breakfast'],
        ['🥯', 'bagel', 'breakfast'],
        ['🧀', 'cheese wedge', 'cheese'],
        ['🥚', 'egg', 'breakfast'],
        ['🍳', 'cooking', 'egg breakfast'],
        ['🥓', 'bacon', 'breakfast'],
        ['🍔', 'hamburger', 'burger lunch'],
        ['🍟', 'french fries', 'chips'],
        ['🍕', 'pizza', 'lunch friday'],
        ['🌭', 'hot dog', 'sausage'],
        ['🥪', 'sandwich', 'lunch'],
        ['🌮', 'taco', 'mexican'],
        ['🌯', 'burrito', 'mexican'],
        ['🥗', 'green salad', 'healthy lunch'],
        ['🍝', 'spaghetti', 'pasta'],
        ['🍜', 'steaming bowl', 'ramen noodles'],
        ['🍣', 'sushi', 'japanese'],
        ['🥟', 'dumpling', 'yum cha'],
        ['🍦', 'soft ice cream', 'dessert'],
        ['🍩', 'doughnut', 'donut'],
        ['🍪', 'cookie', 'biscuit'],
        ['🎂', 'birthday cake', 'birthday celebrate'],
        ['🍰', 'shortcake', 'cake dessert'],
        ['🧁', 'cupcake', 'cake'],
        ['🍫', 'chocolate bar', 'sweet'],
        ['🍿', 'popcorn', 'movie watching'],
        ['☕', 'hot beverage', 'coffee tea'],
        ['🍵', 'teacup without handle', 'tea'],
        ['🧋', 'bubble tea', 'boba'],
        ['🥤', 'cup with straw', 'drink'],
        ['🍺', 'beer mug', 'beer drinks friday'],
        ['🍻', 'clinking beer mugs', 'cheers drinks'],
        ['🥂', 'clinking glasses', 'cheers celebrate'],
        ['🍷', 'wine glass', 'wine'],
        ['🍸', 'cocktail glass', 'drinks'],
        ['🍾', 'bottle with popping cork', 'celebrate champagne'],
    ],
    activity: [
        ['🎉', 'party popper', 'party celebrate tada congrats'],
        ['🎊', 'confetti ball', 'celebrate'],
        ['🎈', 'balloon', 'party birthday'],
        ['🎁', 'wrapped gift', 'present birthday'],
        ['🎄', 'Christmas tree', 'christmas holiday'],
        ['🎃', 'jack-o-lantern', 'halloween'],
        ['🏆', 'trophy', 'win award'],
        ['🥇', '1st place medal', 'gold first win'],
        ['🥈', '2nd place medal', 'silver second'],
        ['🥉', '3rd place medal', 'bronze third'],
        ['🏅', 'sports medal', 'award'],
        ['⚽', 'soccer ball', 'football'],
        ['🏀', 'basketball', 'sport'],
        ['🏈', 'american football', 'sport'],
        ['🏉', 'rugby football', 'footy sport'],
        ['🏏', 'cricket game', 'cricket sport'],
        ['🎾', 'tennis', 'sport'],
        ['⛳', 'flag in hole', 'golf'],
        ['🏄', 'person surfing', 'surf beach', 1],
        ['🚴', 'person biking', 'cycle bike', 1],
        ['🏊', 'person swimming', 'swim', 1],
        ['🏋️', 'person lifting weights', 'gym', 1],
        ['🎯', 'bullseye', 'target goal'],
        ['🎮', 'video game', 'gaming'],
        ['🎲', 'game die', 'dice random'],
        ['🧩', 'puzzle piece', 'puzzle'],
        ['🎨', 'artist palette', 'design art'],
        ['🎬', 'clapper board', 'film action'],
        ['🎤', 'microphone', 'sing karaoke'],
        ['🎧', 'headphone', 'music focus'],
        ['🎵', 'musical note', 'music'],
        ['🎸', 'guitar', 'music rock'],
        ['🎹', 'musical keyboard', 'piano'],
    ],
    travel: [
        ['🚗', 'automobile', 'car'],
        ['🚕', 'taxi', 'uber'],
        ['🚌', 'bus', 'transport'],
        ['🚆', 'train', 'transport'],
        ['🚇', 'metro', 'subway'],
        ['🚲', 'bicycle', 'bike'],
        ['🛴', 'kick scooter', 'scooter'],
        ['✈️', 'airplane', 'flight travel'],
        ['🛫', 'airplane departure', 'flight'],
        ['🚀', 'rocket', 'launch ship deploy'],
        ['🛸', 'flying saucer', 'ufo'],
        ['⛵', 'sailboat', 'boat'],
        ['🚢', 'ship', 'boat'],
        ['⚓', 'anchor', 'ship'],
        ['🚧', 'construction', 'wip work in progress'],
        ['🚦', 'vertical traffic light', 'traffic'],
        ['🗺️', 'world map', 'map'],
        ['🏠', 'house', 'home'],
        ['🏡', 'house with garden', 'home'],
        ['🏢', 'office building', 'office work'],
        ['🏥', 'hospital', 'health'],
        ['🏖️', 'beach with umbrella', 'holiday beach'],
        ['🏝️', 'desert island', 'holiday'],
        ['🏔️', 'snow-capped mountain', 'mountain'],
        ['⛺', 'tent', 'camping'],
        ['🌅', 'sunrise', 'morning'],
        ['🌃', 'night with stars', 'night'],
        ['🎡', 'ferris wheel', 'fun'],
        ['🗽', 'Statue of Liberty', 'new york'],
    ],
    objects: [
        ['⌚', 'watch', 'time'],
        ['📱', 'mobile phone', 'phone iphone'],
        ['💻', 'laptop', 'computer'],
        ['🖥️', 'desktop computer', 'computer'],
        ['⌨️', 'keyboard', 'typing'],
        ['🖱️', 'computer mouse', 'mouse'],
        ['🖨️', 'printer', 'print'],
        ['💾', 'floppy disk', 'save'],
        ['📷', 'camera', 'photo'],
        ['🎥', 'movie camera', 'video'],
        ['📞', 'telephone receiver', 'call phone'],
        ['📺', 'television', 'tv'],
        ['⏰', 'alarm clock', 'time deadline'],
        ['⏳', 'hourglass not done', 'waiting time'],
        ['🔋', 'battery', 'power'],
        ['🔌', 'electric plug', 'power'],
        ['💡', 'light bulb', 'idea'],
        ['🔦', 'flashlight', 'torch'],
        ['💸', 'money with wings', 'spend cost'],
        ['💰', 'money bag', 'money budget'],
        ['💳', 'credit card', 'payment'],
        ['🧾', 'receipt', 'invoice'],
        ['💎', 'gem stone', 'diamond'],
        ['⚖️', 'balance scale', 'legal'],
        ['🔧', 'wrench', 'fix tool'],
        ['🔨', 'hammer', 'build tool'],
        ['🛠️', 'hammer and wrench', 'tools fix'],
        ['⚙️', 'gear', 'settings'],
        ['🧰', 'toolbox', 'tools'],
        ['🔗', 'link', 'url'],
        ['🧲', 'magnet', 'magnet'],
        ['🧪', 'test tube', 'test experiment'],
        ['🔬', 'microscope', 'science'],
        ['🔭', 'telescope', 'science'],
        ['💊', 'pill', 'medicine'],
        ['🩺', 'stethoscope', 'doctor medical appointment'],
        ['🦷', 'tooth', 'dentist'],
        ['🩹', 'adhesive bandage', 'fix patch'],
        ['🧹', 'broom', 'clean up'],
        ['🗑️', 'wastebasket', 'trash delete'],
        ['🔑', 'key', 'password'],
        ['🔒', 'locked', 'secure private'],
        ['🔓', 'unlocked', 'open'],
        ['🛡️', 'shield', 'security'],
        ['🚪', 'door', 'exit'],
        ['🪑', 'chair', 'seat'],
        ['🛋️', 'couch and lamp', 'relax'],
        ['📦', 'package', 'ship box delivery'],
        ['📫', 'closed mailbox with raised flag', 'mail'],
        ['✉️', 'envelope', 'email mail'],
        ['📧', 'e-mail', 'email'],
        ['📨', 'incoming envelope', 'email'],
        ['📝', 'memo', 'note write'],
        ['📄', 'page facing up', 'document'],
        ['📃', 'page with curl', 'document'],
        ['📑', 'bookmark tabs', 'document'],
        ['📊', 'bar chart', 'stats report'],
        ['📈', 'chart increasing', 'growth up'],
        ['📉', 'chart decreasing', 'down'],
        ['📋', 'clipboard', 'copy list'],
        ['📌', 'pushpin', 'pin'],
        ['📍', 'round pushpin', 'location'],
        ['📎', 'paperclip', 'attach'],
        ['✂️', 'scissors', 'cut'],
        ['🖊️', 'pen', 'write sign'],
        ['✏️', 'pencil', 'edit'],
        ['📁', 'file folder', 'folder'],
        ['📂', 'open file folder', 'folder'],
        ['🗂️', 'card index dividers', 'organise'],
        ['📅', 'calendar', 'date'],
        ['📆', 'tear-off calendar', 'date'],
        ['🗓️', 'spiral calendar', 'schedule'],
        ['📚', 'books', 'read docs'],
        ['📖', 'open book', 'read'],
        ['🔖', 'bookmark', 'save'],
        ['🏷️', 'label', 'tag'],
        ['📣', 'megaphone', 'announce'],
        ['📢', 'loudspeaker', 'announce'],
        ['🔔', 'bell', 'notification'],
        ['🔕', 'bell with slash', 'mute'],
        ['🔍', 'magnifying glass tilted left', 'search'],
        ['🔎', 'magnifying glass tilted right', 'search'],
        ['🧭', 'compass', 'direction'],
        ['🎓', 'graduation cap', 'learn'],
        ['☂️', 'umbrella', 'rain'],
        ['🕶️', 'sunglasses', 'cool'],
        ['👔', 'necktie', 'formal'],
        ['👕', 't-shirt', 'shirt'],
        ['🎒', 'backpack', 'school'],
        ['🧳', 'luggage', 'travel'],
    ],
    symbols: [
        ['✅', 'check mark button', 'done yes ok complete'],
        ['☑️', 'check box with check', 'done'],
        ['✔️', 'check mark', 'done yes'],
        ['❌', 'cross mark', 'no wrong'],
        ['❎', 'cross mark button', 'no'],
        ['➕', 'plus', 'add'],
        ['➖', 'minus', 'remove'],
        ['❓', 'red question mark', 'question'],
        ['❔', 'white question mark', 'question'],
        ['❗', 'red exclamation mark', 'important'],
        ['‼️', 'double exclamation mark', 'important'],
        ['⁉️', 'exclamation question mark', 'what'],
        ['⚠️', 'warning', 'caution alert'],
        ['🚫', 'prohibited', 'no forbidden'],
        ['⛔', 'no entry', 'stop blocked'],
        ['🛑', 'stop sign', 'stop'],
        ['🔴', 'red circle', 'red'],
        ['🟠', 'orange circle', 'orange'],
        ['🟡', 'yellow circle', 'yellow'],
        ['🟢', 'green circle', 'green online'],
        ['🔵', 'blue circle', 'blue'],
        ['🟣', 'purple circle', 'purple'],
        ['⚫', 'black circle', 'black'],
        ['⚪', 'white circle', 'white'],
        ['🟥', 'red square', 'red'],
        ['🟩', 'green square', 'green'],
        ['🟦', 'blue square', 'blue'],
        ['⬆️', 'up arrow', 'up'],
        ['⬇️', 'down arrow', 'down'],
        ['⬅️', 'left arrow', 'left back'],
        ['➡️', 'right arrow', 'right next'],
        ['↩️', 'right arrow curving left', 'reply back'],
        ['🔄', 'counterclockwise arrows button', 'refresh sync retry'],
        ['🔁', 'repeat button', 'repeat'],
        ['🔃', 'clockwise vertical arrows', 'reload'],
        ['🆕', 'NEW button', 'new'],
        ['🆗', 'OK button', 'ok'],
        ['🆙', 'UP! button', 'up'],
        ['🆒', 'COOL button', 'cool'],
        ['🆓', 'FREE button', 'free'],
        ['🔝', 'TOP arrow', 'top'],
        ['🔜', 'SOON arrow', 'soon'],
        ['ℹ️', 'information', 'info'],
        ['🔢', 'input numbers', 'numbers'],
        ['#️⃣', 'keycap: #', 'hash number'],
        ['1️⃣', 'keycap: 1', 'one'],
        ['2️⃣', 'keycap: 2', 'two'],
        ['3️⃣', 'keycap: 3', 'three'],
        ['🔟', 'keycap: 10', 'ten'],
        ['♻️', 'recycling symbol', 'recycle'],
        ['✳️', 'eight-spoked asterisk', 'asterisk'],
        ['❇️', 'sparkle', 'sparkle'],
        ['💲', 'heavy dollar sign', 'money'],
        ['©️', 'copyright', 'copyright'],
        ['™️', 'trade mark', 'trademark'],
        ['🔅', 'dim button', 'brightness'],
        ['🔆', 'bright button', 'brightness'],
        ['🎶', 'musical notes', 'music'],
        ['〰️', 'wavy dash', 'wave'],
        ['➰', 'curly loop', 'loop'],
        ['🏁', 'chequered flag', 'finish done race'],
        ['🚩', 'triangular flag', 'flag red flag'],
        ['🏳️', 'white flag', 'surrender'],
        ['🏴', 'black flag', 'flag'],
        ['🏳️‍🌈', 'rainbow flag', 'pride'],
    ],
    flags: [
        ['🇦🇺', 'flag: Australia', 'australia aus'],
        ['🇳🇿', 'flag: New Zealand', 'new zealand nz'],
        ['🇬🇧', 'flag: United Kingdom', 'uk britain'],
        ['🇺🇸', 'flag: United States', 'usa america'],
        ['🇨🇦', 'flag: Canada', 'canada'],
        ['🇮🇳', 'flag: India', 'india'],
        ['🇵🇰', 'flag: Pakistan', 'pakistan'],
        ['🇵🇭', 'flag: Philippines', 'philippines'],
        ['🇸🇬', 'flag: Singapore', 'singapore'],
        ['🇯🇵', 'flag: Japan', 'japan'],
        ['🇨🇳', 'flag: China', 'china'],
        ['🇰🇷', 'flag: South Korea', 'korea'],
        ['🇮🇩', 'flag: Indonesia', 'indonesia'],
        ['🇻🇳', 'flag: Vietnam', 'vietnam'],
        ['🇫🇷', 'flag: France', 'france'],
        ['🇩🇪', 'flag: Germany', 'germany'],
        ['🇮🇹', 'flag: Italy', 'italy'],
        ['🇪🇸', 'flag: Spain', 'spain'],
        ['🇳🇱', 'flag: Netherlands', 'netherlands'],
        ['🇮🇪', 'flag: Ireland', 'ireland'],
        ['🇧🇷', 'flag: Brazil', 'brazil'],
        ['🇲🇽', 'flag: Mexico', 'mexico'],
        ['🇿🇦', 'flag: South Africa', 'south africa'],
        ['🇦🇪', 'flag: United Arab Emirates', 'uae dubai'],
    ],
};
export const EMOJI = Object.keys(ROWS).flatMap((category) => ROWS[category].map(([char, name, keywords, tone]) => ({ char, name, keywords: keywords ? keywords.split(' ') : [], category, tone: tone === 1 })));
const BY_CHAR = new Map(EMOJI.map((e) => [e.char, e]));
/** The dataset entry for an emoji (without a skin tone), if it is in the set. */
export const emojiInfo = (char) => BY_CHAR.get(char);
//# sourceMappingURL=emoji-data.js.map